import FetchInterceptor from "configs/FetchInterceptor";

class PromotionDiscountServices {
  static async getAll(requestBody) {
    const apiUrl = "/core/v1/discounts/get/all";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v1/discounts/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async add(requestBody) {
    const apiUrl = "/core/v1/discounts/add";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }

  static async cancel(requestBody) {
    const apiUrl = "/core/v1/discounts/cancel";
    const response = await FetchInterceptor.post(apiUrl, requestBody);
    return response;
  }
}

export default PromotionDiscountServices;
